import React, { createContext, useEffect, useState } from 'react'
import axios from 'axios'
import { Auth } from './Auth'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@chakra-ui/react'





export const Context = createContext() // <- initialize Context using initialState

export const Store = ({ children }) => {
    const [userData, setUser] = useState({})
    const navigate = useNavigate()
    const toast = useToast()
    // const [token] = useState(JSON.parse(window.localStorage.getItem('token')))
    useEffect(() => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/me`,
            headers: {
                'Authorization': Auth()
            }
        };
        if(Auth() !== null) {
            axios.request(config)
                .then((response) => {
                    setUser({ id: response.data.user.id, email: response.data.user.email, firstName: response.data.user.firstName, lastName: response.data.user.lastName, partyId: response.data.user.partyId, userGroupMember: response.data.user.UserGroupMember.map((x) => x.userGroupId), UserGroupPermission: response.data.user.UserGroupPermission.map((z) => z.userPermissionId) });
                    // setUser(response.data.user);
                    // console.log(response.data.user.email,'1111111111111111111111')
                })
                .catch((error) => {
                    console.log("Error catch in user fetch", error)
                    localStorage.removeItem('token')
                    localStorage.removeItem('user')
                    sessionStorage.clear()
                    console.log("navigate to login");
                    navigate('/login')
                    // setUser(error.response.data);
                    // if(error.response.data.message === "Invalid token"){     
                    //     localStorage.removeItem('token')
                    //     localStorage.removeItem('user')
                    //     sessionStorage.clear()
                    // }else {
                    //     toast({
                    //         title: `ERROR : ${error.response.data.message}`,
                    //         status: 'error',
                    //         duration: 3000,
                    //         isClosable: true,
                    //         position: 'top'
                    //       })
                    // }
                });
        }

    }, [navigate,toast])

    const contextData = {
        userData
    }

   
    return (
        <Context.Provider value={contextData} > {/* <- this value is gonna be Global state */}
            {children}
        </Context.Provider>
    )
}